import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { JobClassificationSearchResponse } from '../services/JobClassificationService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/jobs/classifications'), () => {
    return HttpResponse.json<JobClassificationSearchResponse>({
      rows: 25,
      page: 0,
      total: 12,
      results: [
        {
          id: '6',
          label: 'diagnostics',
          type: 'service',
          isDefault: false,
        },
        {
          id: '10',
          label: 'involuntary',
          type: 'transport',
          isDefault: false,
        },
        {
          id: '4',
          label: 'loading',
          type: 'service',
          isDefault: false,
        },
        {
          id: '2',
          label: 'locksmith',
          type: 'service',
          isDefault: false,
        },
        {
          id: '12',
          label: 'police call',
          type: 'service',
          isDefault: false,
        },
        {
          id: '9',
          label: 'registration',
          type: 'service',
          isDefault: false,
        },
        {
          id: '5',
          label: 'repair',
          type: 'service',
          isDefault: false,
        },
        {
          id: '11',
          label: 'skip trace',
          type: 'service',
          isDefault: false,
        },
        {
          id: '8',
          label: 'storage',
          type: 'service',
          isDefault: false,
        },
        {
          id: '1',
          label: 'transport',
          type: 'transport',
          isDefault: false,
        },
        {
          id: '3',
          label: 'unloading',
          type: 'service',
          isDefault: false,
        },
        {
          id: '7',
          label: 'voluntary',
          type: 'transport',
          isDefault: false,
        },
      ],
    });
  }),
];
